
// This file provides backward compatibility for components still importing from '@/utils/toast'
import { toastService } from "./toastService";

// Re-export the toastService methods
export const showSuccessToast = toastService.success;
export const showErrorToast = toastService.error;
export const showInfoToast = toastService.info;
export const showLoadingToast = toastService.loading;
export const dismissToast = toastService.dismiss;
export const dismissAllToasts = toastService.dismissAll;

// Re-export the entire service for direct use
export { toastService };
